import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'dva';
import Button from '../../Button';
import styles from './Alert.module.scss';
import AlertTriangle from '../../../assets/svg/Feather/AlertTriangle';
import { COLORS } from '../../../lib/constants';

function Alert(props) {

  const Icon = props.icon;

  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <div className={styles.alertIcon}>
          <Icon width={20} height={20} color={COLORS.ghOrange} />
        </div>
        <h1 className={styles.title}>{props.title}</h1>
        <h2 className={styles.subtitle}>{props.subtitle}</h2>
        <h3 className={styles.message}>{props.message}</h3>
      </div>
      <div className={styles.actionButtons}>
        {props.actionItems.map((actionItem,index) => {
          return (
            <Button 
              key={index}
              theme={actionItem.theme || Button.THEME.orange}
              size={Button.SIZE.medium}
              className={actionItem.className || styles.actionItem}
              onClick={actionItem.onClick}
            >
              {actionItem.title}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

Alert.defaultProps = {
  icon: AlertTriangle
};

Alert.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  message: PropTypes.string,
  actionItems: PropTypes.array,
  icon: PropTypes.func
};

export default Alert;